import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import './plugins/amplify';
import './plugins/axios';
import './plugins/vue-image-upload-resize';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
//import FlagIcon from 'vue-flag-icon';
//Vue.use(FlagIcon);

import firebase from 'firebase/app';
import 'firebase/messaging';

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyBDeLzHPGIPByQJtzilotQElaTc30mV9lk',
  authDomain: 'prova2-e247b.firebaseapp.com',
  databaseURL: 'https://prova2-e247b.firebaseio.com',
  projectId: 'prova2-e247b',
  storageBucket: 'prova2-e247b.appspot.com',
  messagingSenderId: '187022881762'
};
firebase.initializeApp(config);

try {
  window.messaging = firebase.messaging();
  window.messaging.usePublicVapidKey(
    'BKEA6WTaJ3bIqoBBaJNGwelnjaz27oawvlosxCz4ryf2NccUudG5F_gP631kRnQogrgAtiRimD4emZMvJKIKnVM'
  );
} catch {
  console.warn('Unable init messaging!!');
}

//i18n.locale = 'it';

Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  created: () => {
    console.log(window.localStorage.getItem('settings'));
    let settings = JSON.parse(window.localStorage.getItem('settings')) || {};
    if ('language' in settings) {
      i18n.locale = settings.language;
    }
    if (window.messaging) {
      window.messaging
        .requestPermission()
        .then(function() {
          console.log('Notification permission granted.');

          /*
          messaging.getToken()
            .then(function(token) {
              //commit('setMessagingToken', token);
              console.log('FCM token: ', token);
            })
            .catch(function(err) {
              console.error('Unable to retrieve refreshed token ', err);
              //commit('setMessagingToken', null);
            });
            */
        })
        .catch(function(err) {
          console.warn('Unable to get permission to notify', err);
          //commit('setMessagingToken', null);
        });
    }
  }
});
